import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { ReactNode } from "react";
interface FormProps {
  children: ReactNode;
  id?: string;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
}
export const Form = t0 => {
  const $ = _c(4);
  const {
    children,
    id,
    onSubmit
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== id || $[2] !== onSubmit) {
    t1 = <form id={id} onSubmit={onSubmit} className="space-y-m w-full">{children}</form>;
    $[0] = children;
    $[1] = id;
    $[2] = onSubmit;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
interface FormRowProps {
  children: ReactNode;
  className?: string;
}
export const FormRow = t0 => {
  const $ = _c(5);
  const {
    children,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `grid grid-cols-12 gap-x-s gap-y-3s ${className}`;
  let t3;
  if ($[0] !== t2) {
    t3 = t2.trim();
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== t3) {
    t4 = <div className={t3}>{children}</div>;
    $[2] = children;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export type ColumnCount = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
interface FormFieldProps {
  children: ReactNode;
  columns?: ColumnCount;
  className?: string;
  newRow?: boolean;
}
const columnSpanMap: Record<ColumnCount, string> = {
  1: "col-span-1",
  2: "col-span-2",
  3: "col-span-3",
  4: "col-span-4",
  5: "col-span-5",
  6: "col-span-6",
  7: "col-span-7",
  8: "col-span-8",
  9: "col-span-9",
  10: "col-span-10",
  11: "col-span-11",
  12: "col-span-12"
};
export const FormField = t0 => {
  const $ = _c(7);
  const {
    children,
    columns: t1,
    className: t2,
    newRow: t3
  } = t0;
  const columns = t1 === undefined ? 12 : t1;
  const className = t2 === undefined ? "" : t2;
  const newRow = t3 === undefined ? false : t3;
  const colSpanClass = columnSpanMap[columns];
  let t4;
  if ($[0] !== className || $[1] !== colSpanClass || $[2] !== newRow) {
    t4 = clsx(colSpanClass, className, {
      "col-start-1": newRow
    });
    $[0] = className;
    $[1] = colSpanClass;
    $[2] = newRow;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children || $[5] !== t4) {
    t5 = <div className={t4}>{children}</div>;
    $[4] = children;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};